import { ActionType } from "../../../../../react-core/Flux/ActionType";
import { PensionSubAccountSettingsClient } from "../../../../../Wrap/Api/Account/PensionSubAccountSettings";
import { InstructionWorkflowClient } from "../../../../../Wrap/Api/Instruction/InstructionWorkflow";
import { AdvisersClient } from "../../../../../Wrap/Api/Network/Advisers";
import { DashboardFilterClient } from "../../../../../Wrap/Api/User/DashboardFilter";
import { DashboardFilterReorderClient } from "../../../../../Wrap/Api/User/DashboardFilterReorder";
import { DashboardFiltersClient } from "../../../../../Wrap/Api/User/DashboardFilters";
import { ClientDashboardFiltersModel } from "../../../../../Wrap/Models/Domains/Users/DashboardFilter/ClientDashboardFiltersModel";
import { PensionSubAccountSettingsDispatcher } from "../../../Stroes/Variable";
import { DashboardFilterDispatcher, DashboardFilterStore } from "../Store/Variable";

export class DashboardAction {
    public static getFilterList() {
        const client = new DashboardFilterClient();
        const promise = client.get();
        promise.onSuccess((data) => {
            DashboardFilterDispatcher.dispatch({ actionType: ActionType.Success, payload: data });
        });
        promise.onError((data) => {});
    }

    public static updateFilterList(companyCode: string, adviserId: number, callback?) {
        const client = new DashboardFiltersClient();
        const promise = client.put(companyCode, adviserId);
        promise.onSuccess((data) => {
            if (callback) {callback(data);}
        });
        promise.onError((data) => {});
    }

    public static getAdviserIds() {
        const client = new AdvisersClient();
        const promise = client.get("", "", 1, 9999999, false);
        promise.onSuccess((data) => {
            DashboardFilterDispatcher.dispatch({ actionType: ActionType.Loading, payload: data });
        });
        promise.onError((data) => {});
    }

    public static setPressedId(id: number, save?: boolean) {
        const currentId = DashboardFilterStore.getPressedId();
        let pressedId = null;
        if (save && currentId == id) {
            return DashboardFilterDispatcher.dispatch({ actionType: ActionType.Update, payload: id });
        }
        if (save != true) {
            if (id !== currentId) {
                pressedId = id;
            }
            DashboardFilterDispatcher.dispatch({ actionType: ActionType.Update, payload: pressedId });
        }
    }

    public static postDashboardFilter(data: ClientDashboardFiltersModel) {
        const client = new DashboardFilterClient();
        const promise = client.post(data);

        promise.onSuccess((data) => {
            DashboardFilterDispatcher.dispatch({ actionType: ActionType.Success, payload: data });
        });
        promise.onError((data) => {});
    }

    public static putDashboardFilter(data: ClientDashboardFiltersModel) {
        const client = new DashboardFilterClient();
        const promise = client.put(data);

        promise.onSuccess((d) => {
            DashboardFilterDispatcher.dispatch({ actionType: ActionType.Success, payload: d });
            DashboardAction.setPressedId(data.FilterId, true);
        });
        promise.onError((data) => {});
    }

    public static orderDashboardFilter(data: ClientDashboardFiltersModel[]) {
        const client = new DashboardFilterReorderClient();
        const promise = client.put(data);

        promise.onSuccess((data) => {
            DashboardFilterDispatcher.dispatch({ actionType: ActionType.Success, payload: data });
        });
        promise.onError((data) => {});
    }

    public static deleteDashboardFilter(data: ClientDashboardFiltersModel) {
        const client = new DashboardFilterClient();
        const promise = client.delete(data);
        promise.onSuccess((d) => {
            DashboardFilterDispatcher.dispatch({ actionType: ActionType.Success, payload: d });
            if (data?.FilterId == DashboardFilterStore.getPressedId()) {
                DashboardFilterDispatcher.dispatch({ actionType: ActionType.Update, payload: null });
            }
        });
        promise.onError((data) => {});
    }

    public static getWorkflowTable(query, callback) {
        const client = new InstructionWorkflowClient();
        const promise = client.get(
            query.beginDate,
            query.endDate,
            query.advisers,
            query.product,
            query.activity,
            query.status,
            query.company,
            query.network,
            query.start,
            query.count,
            query.headAccountHierarchyIds,
            query.subAccountHierarchyIds,
            query.customerId
        );
        promise.onSuccess((data) => {
            callback(data);
        });
        promise.onError((data) => {});
    }

    public static loadPensionSubAccountSettings(subAccountHierarchyId: string){
        const client = new PensionSubAccountSettingsClient();
        const promise = client.get(subAccountHierarchyId, true);

        PensionSubAccountSettingsDispatcher.dispatch({ actionType: ActionType.Loading });

        promise.onSuccess((data) => {
            PensionSubAccountSettingsDispatcher.dispatch({ actionType: ActionType.Success, payload: data });
        });

        promise.onError((data) => {
            PensionSubAccountSettingsDispatcher.dispatch({ actionType: ActionType.Error });
        });
    }
}
